import styled, { css, StyledFunction } from "styled-components";

export const palette = {
  exampleColor: '#F0F0F0',
  silver: '#D3D3D3',
  basicGray: '#D0D0D0',
  almostWhite: '#eeeeee',
  sublimeGray: '#a5a5a5',
  darkerGray: '#2B4141',
  someBlue: '#0076af',
  primaryColor: '#022759',
  secondaryColor: '#3DBC94',
  secondaryColorShy: '#4EC29D',
  terciaryColor: '#08AEEA',
  secondaryButtonGray: 'rgb(233,233,233)',
  terciaryColorShy: '#34BCED',
  finautaOrange: '#FE4A49',
  finautaOldOrange: '#FF9D39',
  secondaryActiveText: '#009287',
  secondaryActiveBg: '#bfffeb',
  sweetGray: '#f4f5f7',
  interestGray: '#e1e1e1',
  sweetPurple: '#756AE7',
  white: '#FFF',
  disabled: '#a5a5a5',
  titlesColors: '#1d2d35',
  textColor: '#2B4141',
  preClick: '#304E77',
  okGreen: '#22E00B',
  marron: '#6B0504',
  morado: '#564787',
  azulClaro: '#3AAFB9',
  azulFuerte: '#03254E',
  primaryOpacity: (alfa: number) => `rgba(2, 39, 89,${alfa})`,
};

export const breakpoints = {
  exception: '@media screen and (min-width: 360px)',
  mobileLandscape: '@media screen and (min-width: 440px)',
  tablet: '@media screen and (min-width: 570px)',
  tabletLandscape: '@media screen and (min-width: 770px)',
  desktop: '@media screen and (min-width: 1024px)',
  desktop2: '@media screen and (min-width: 1109px)',
  desktop3: '@media screen and (min-width: 1194px)',
  larger: '@media screen and (min-width: 1280px)',
};

export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 15px 0;
`;

export const StyledLabel = styled.label`
    font-weight: 600;
`;

export const inputStyle = {
  border: '1px solid #999999',
  outline: 'none',
  backgroundColor: '#ffffff',
  borderRadius: '0',
  outlineWidth: 0,
  WebkitAppearance: 'none',
  'boxShadow': 'none !important',
  minWidth: '200px',
}

export const ErrorMsg = styled.div`
  color: #ffffff;
  background-color: #FF0033;
  font-weight: 600;
  margin: 2px;
  padding: 5px;
  border-radius: 5px;
  max-width: 300px;
`;

export const div: StyledFunction<any> = styled.div;

export const FlexRow = div`
  display: flex;
  align-items: center;
  * {
    margin: 0 5px;
  }
    ${({ justifyContent }) => justifyContent && css`
      justify-content: ${justifyContent};
  `}
`;

export const StyledHeader = styled.div`
display: flex;
align-items: center;
justify-content: space-around;
`;

export const FabContainer = div`
position: fixed;
border-radius: 50%;
top: 85%;
color: ${palette.white};
background-color: ${palette.primaryColor};
${({ top }) => top && css`
    top: ${top}%;
`}
${({ backgroundColor }) => backgroundColor && css`
    background-color: ${backgroundColor};
`}
left: 80%;
width: 60px;
height: 60px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
${breakpoints.tablet} {
  left: 90%;
  top: 90%;
  ${({ top }) => top && css`
    top: ${top + 5}%;
    left: 90%;
`}
}
`;

export const ScrollableContent = div`
  max-height: 80vh;
  overflow-y: scroll;
  ${({ maxHeight }) => maxHeight && css`
    max-height: ${maxHeight};
    left: 90%;
`}
`;
export const FixedHeightContent = div`
  max-height: 70vh;
    ${({ maxHeight }) => maxHeight && css`
    max-height: ${maxHeight};
    left: 90%;
`}

`;